import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function DownloadIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M11 3.5C11 2.94772 11.4477 2.5 12 2.5C12.5522 2.5 13 2.94772 13 3.5V13.5859L14.7929 11.793C15.1834 11.4024 15.8165 11.4024 16.207 11.793C16.5975 12.1835 16.5975 12.8165 16.207 13.207L12.707 16.707C12.3409 17.0731 11.7619 17.0957 11.3691 16.7754L11.2929 16.707L7.79293 13.207L7.72457 13.1309C7.40422 12.7381 7.42681 12.1591 7.79293 11.793C8.15904 11.4269 8.73804 11.4043 9.13082 11.7246L9.20699 11.793L11 13.5859V3.5Z"
				fill="currentColor"
			/>
			<path
				d="M19.0136 17.3359C19.1044 16.7913 19.6194 16.4231 20.164 16.5137C20.7087 16.6045 21.0769 17.1194 20.9863 17.6641L20.7646 18.9932C20.5235 20.4398 19.2721 21.5 17.8056 21.5H6.19429C4.81946 21.5 3.63349 20.5682 3.29195 19.2598L3.23531 18.9932L3.01363 17.6641L3.00191 17.5625C2.96963 17.0568 3.32524 16.5988 3.83589 16.5137C4.34645 16.4287 4.83136 16.7466 4.9648 17.2354L4.98629 17.3359L5.20796 18.6641L5.22652 18.7529C5.34024 19.1893 5.73588 19.5 6.19429 19.5H17.8056C18.2945 19.5 18.7116 19.1462 18.7919 18.6641L19.0136 17.3359Z"
				fill="currentColor"
			/>
		</svg>
	);
}

DownloadIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default DownloadIcon;
